// extracted by mini-css-extract-plugin
export default {"label":"Login_label__awFML","submitButton":"Login_submitButton__FOiBi","login":"Login_login__XCM01","error":"Login_error__FKGdT"};